export { IxDivider } from './IxDivider.js';
